import React, { FC } from 'react';
import { NavPrivate } from './NavPrivate';
import { NavPublic } from './NavPublic';
import { useUser } from '../user/useUser';
import { NavHeader } from './components/header/NavHeader';
import { NavGroup } from './components/group/NavGroup';

export const Navigation: FC = () => {
  const { loggedIn, currentUser, accessPremium } = useUser();
  return (
    <NavHeader>
      <NavGroup>
        {loggedIn && (
          <NavPrivate currentUser={currentUser} accessPremium={accessPremium} />
        )}
        {!loggedIn && <NavPublic />}
      </NavGroup>
    </NavHeader>
  );
};
